import { render, staticRenderFns } from "./privileges.vue?vue&type=template&id=2d658c1b"
import script from "./privileges.vue?vue&type=script&lang=js"
export * from "./privileges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports